<template>
    <v-card flat width="250px" class="d-flex flex-column align-center">
        <v-card-title style="word-break: break-word;"
            class="font-weight-bold text-body-1 primary--text text--lighten-1 text-center">
            {{ (label !== '') ? label : 'CERTIFICADO' }}
        </v-card-title>
        <input ref="fileInput" type="file" style="display: none;" accept=".png ,.jpg, .jpeg, .pdf"
            @change="handleFileUpload">
        <v-card v-if="loading" class="d-flex flex align-center justify-center" min-width="200" width="200" height="110"
            flat>
            <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
        </v-card>
        <div v-else class="ma-0 pa-0 d-flex flex-column align-center">
            <v-card-text class="ma-0 pa-0 font-weight-regular text-center primary--text " v-if="subtitle">
                {{ subtitle }}
            </v-card-text>
            <v-card flat v-if="!imagePreview" class="d-flex flex-column justify-center align-center rounded-0"
                width="200" height="110" @click=handleFileImport>
                <v-card-text class="d-flex justify-center align-center">
                    <v-img :src="getImage" contain height="100"></v-img>
                </v-card-text>
            </v-card>
        </div>
        <v-btn v-if="!imagePreview" :disabled="loading" width="200" elevation="0" color="primary" class="pa-5 rounded-0"
            @click=handleFileImport>
            <v-icon class="mr-2">mdi-plus</v-icon>
            cargar archivo
        </v-btn>
        <canvas ref="canvas" style="display: none;"></canvas>
        <v-card v-if="imagePreview" min-width="200" width="200" height="110" class="justify-center align-center" flat
            :color="(fileName) ? 'grey lighten-2' : ''">
            <div v-if="fileName" class="d-flex mt-2 flex-column justify-center align-center">
                <img :src="imagePreview" alt="Archivo .pdf cargado" width="60">
                <v-chip dense>{{ fileName }}</v-chip>
            </div>
            <div v-else class="d-flex flex justify-center">
                <img :src="imagePreview" alt="Imagen previa" min-width="176" height="110">
            </div>
        </v-card>
        <v-btn v-if="imagePreview" outlined @click="deleteImage" width="200" :disabled="habilitarEliminar"
            color="secondary" class="py-5  rounded-0">
            <v-icon class="mr-2">mdi-delete-outline</v-icon>
            eliminar
        </v-btn>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import imagePdf from '@/assets/pdf-ok-20.png'

import archivoGen from '@/assets/inputs/archivo-general.png'
import dniFrente from '@/assets/inputs/dni-frente.png'
import dniDorso from '@/assets/inputs/dni-dorso.png'
import tituloFrente from '@/assets/inputs/titulo-frente.png'
import tituloDorso from '@/assets/inputs/titulo-dorso.png'
import tarjetaCredito from '@/assets/inputs/tarjeta-credito_2.png'



export default {
    data() {
        return {
            selectedFiles: [],
            imagePreview: null,
            fileSizeError: false,
            loading: false,
            fileSizeErrorMessage: '',
            image: imagePdf,
            fileName: '',
            uploadTimeout: null // Added to track the timeout
        };
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated']),

        habilitarEliminar() {
            return (this.disabled)
        },
        getImage() {
            if (this.op.includes('dniFrente')) return dniFrente
            else if (this.op.includes('dniDorso')) return dniDorso
            else if (this.op.includes('titFrente')) return tituloFrente
            else if (this.op.includes('titDorso')) return tituloDorso
            else if (this.op.includes('tarjetaFrente')) return tarjetaCredito
            else return archivoGen
        }
    },
    methods: {
        ...mapActions('dataUser', ['addFiles']),
        ...mapActions('preafiliacion', ['addFilesPre']),
        ...mapActions('notificaciones', ['showSnack']),

        handleFileImport() {
            // Trigger click on the FileInput
            try {
                this.$refs.fileInput.click();
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },
        handleFileUpload(event) {

            const file = event.target.files[0]
            const tipo = event.target.files[0].type
            const size = event.target.files[0].size
            if (file) {
                this.loading = true;
                //verificar que el nombre del archivo contenga solo un punto
                if (file.name.split('.').length > 2) {
                    this.fileSizeError = true;
                    this.fileSizeErrorMessage = 'El nombre del archivo no puede contener más de un punto.';
                    this.showSnack({
                        message: this.fileSizeErrorMessage,
                        type: "400"
                    });
                    this.loading = false;
                    return;
                }

                // Unsupported types (e.g. HEIC, WebP) match no branch below and would
                // spin until the 30s timeout: reject them up front with a clear message
                const tiposPermitidos = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
                if (!tiposPermitidos.includes(tipo)) {
                    this.fileSizeError = true;
                    this.fileSizeErrorMessage = 'Formato no soportado. Subí una foto JPG/PNG o un PDF.';
                    this.showSnack({
                        message: this.fileSizeErrorMessage,
                        type: "400"
                    });
                    this.loading = false;
                    return;
                }

                // Set a timeout to reset the component after 30 seconds
                this.uploadTimeout = setTimeout(() => {
                    this.resetComponent();
                    this.showSnack({
                        message: 'La carga del archivo ha excedido el tiempo límite',
                        type: "400"
                    });
                }, 30000);

                if (tipo == 'application/pdf') {
                    if (size <= 5 * 1024 * 1024) {
                        this.selectedFiles.push(file);
                        (this.isAuthenticated) ? this.addFiles({ file: file, op: this.op }) : this.addFilesPre({ file: file, op: this.op })
                        this.$emit('fileSelected')
                        this.showImagePreview(this.image)
                        this.fileName = file.name
                        clearTimeout(this.uploadTimeout); // Clear timeout on successful upload
                    }
                    else {
                        this.fileSizeError = true;
                        this.fileSizeErrorMessage = 'El archivo no puede superar los 5MB.'
                        this.showSnack({
                            message: this.fileSizeErrorMessage,
                            type: "400"
                        })
                        this.loading = false
                        clearTimeout(this.uploadTimeout); // Clear timeout on error
                    }
                }
                else if ((tipo == 'image/jpeg' || tipo == 'image/jpg' || tipo == 'image/png')) {
                    if (size < 3 * 1024 * 1024) {
                        this.fileSizeError = false;
                        this.compressAndConvertToPNG(file)
                            .then(imageUrl => {
                                this.selectedFiles.push(file);
                                (this.isAuthenticated) ? this.addFiles({ file: file, op: this.op }) : this.addFilesPre({ file: file, op: this.op })
                                this.$emit('fileSelected')
                                this.showImagePreview(imageUrl);
                                clearTimeout(this.uploadTimeout); // Clear timeout on successful upload
                                this.loading = false;
                            })
                            .catch(error => {
                                console.error('Error al procesar la imagen:', error);
                                clearTimeout(this.uploadTimeout); // Clear timeout on error
                                this.loading = false;
                            });
                    } else {
                        this.reduceImageSize(file, 800).then(reducedFile => {
                            this.compressAndConvertToPNG(reducedFile).then(imageUrl => {
                                //this.selectedFiles.push(reducedFile);
                                (this.isAuthenticated) ? this.addFiles({ file: reducedFile, op: this.op }) : this.addFilesPre({ file: reducedFile, op: this.op })
                                this.$emit('fileSelected');
                                this.showImagePreview(imageUrl)
                                clearTimeout(this.uploadTimeout); // Clear timeout on successful upload
                                this.loading = false;
                            }).catch(error => {
                                console.error('Error al comprimir la imagen:', error);
                                clearTimeout(this.uploadTimeout);
                                this.loading = false;
                            })
                        }).catch(error => {
                            console.error('Error al procesar la imagen:', error);
                            clearTimeout(this.uploadTimeout); // Clear timeout on error
                            this.loading = false;
                        });
                    }
                }
            } else {
                this.loading = false
                console.log('error')
            }
        },
        resetComponent() {
            this.selectedFiles = [];
            this.imagePreview = null;
            this.fileName = '';
            this.loading = false;
            this.$refs.fileInput.value = ''; // Reset file input
            clearTimeout(this.uploadTimeout); // Clear any active timeout
        },
        deleteImage() {
            this.selectedFiles = [];
            (this.isAuthenticated) ? this.addFiles({ file: '', op: this.op }) : this.addFilesPre({ file: '', op: this.op })
            this.$emit('fileSelected')
            this.imagePreview = null;
            this.fileName = '';
            this.$refs.fileInput.value = ''; // Limpiar el valor del input file
            this.resetComponent(); // Use resetComponent to ensure consistency
        },
        reduceImageSize(file, maxWidth) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        const aspectRatio = img.width / img.height;
                        let newWidth = maxWidth;
                        let newHeight = maxWidth / aspectRatio;
                        if (img.width > maxWidth) {
                            canvas.width = newWidth;
                            canvas.height = newHeight;
                            ctx.drawImage(img, 0, 0, newWidth, newHeight);
                            canvas.toBlob((blob) => {
                                const reducedFile = new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() });
                                resolve(reducedFile);
                            }, 'image/jpeg');
                        } else {
                            resolve(file); // No es necesario reducir el tamaño
                        }
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        compressAndConvertToPNG(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = this.$refs.canvas;
                        const ctx = canvas.getContext('2d');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);
                        canvas.toBlob((blob) => {
                            const imageUrl = URL.createObjectURL(blob);
                            resolve(imageUrl);
                        }, 'image/png');
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        showImagePreview(imageUrl) {
            this.loading = false
            this.imagePreview = imageUrl;
        }
    },
    props: ['label', 'op', 'disabled', 'subtitle'],
};
</script>
